import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/backend/client';

export function useAdminAuth() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    const checkAdmin = async () => {
      const query = () =>
        supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .eq('role', 'admin')
          .maybeSingle();

      try {
        const { data, error } = await query();

        // PostgREST returns PGRST301 when the JWT is expired.
        // Refresh and retry once before giving up.
        if (error && (error as any).code === 'PGRST301') {
          const { error: refreshError } = await supabase.auth.refreshSession();
          if (refreshError) {
            setIsAdmin(false);
          } else {
            const { data: retryData, error: retryError } = await query();
            setIsAdmin(!!retryData && !retryError);
          }
          return;
        }

        setIsAdmin(!!data && !error);
      } catch {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, [user, authLoading]);

  return { isAdmin, loading: loading || authLoading, user };
}
